import React from 'react';
import PropTypes from 'prop-types';

const LoadingFullContainerContent = ({ children }) => (
  <div style={{
    background: '#222222cc',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: '2',
    top: '0',
    left: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}
  >
    {children}
  </div>
);


LoadingFullContainerContent.defaultProps = {
  children: <p style={{ fontWeight: 'bold', color: '#FFF' }}>Cargando...</p>,
};

LoadingFullContainerContent.propTypes = {
  children: PropTypes.any,
};

export default LoadingFullContainerContent;
